<template>
  <div class="soar-container h-full">
    <OnboardingForm v-if="hasToken"></OnboardingForm>

    <RegistrationForm
      v-else
      :is-submitted="isSubmitted"
      class="w-full flex flex-col gap-y-4 mt-4"
      @onSubmit="onSubmit"
    >
      <template #title>
        <HeaderTypo
          as="h1"
          class="font-thin leading-6 !text-2xl p-5 bg-[#fcfdfd] border-b border-[#dee5e7] !text-brand-black-secondary"
          >{{ $t('register') }} - {{ $t('individuals') }}</HeaderTypo
        >
      </template>
      <template #info>
        <HeaderTypo as="h3" class="text-xl !text-brand-black-secondary">{{
          $t('individualRegistration')
        }}</HeaderTypo>
        <ul class="list-disc ps-12 !text-brand-black-secondary">
          <li>{{ $t('individualPublicNote2') }}</li>
          <li>{{ $t('individualPublicNote3') }}</li>
          <li>{{ $t('individualPublicNote4') }}</li>
          <li>{{ $t('individualPublicNote5') }}</li>
          <li>{{ $t('individualPublicNote6') }}</li>
        </ul>
        <span>{{ $t('registrationLinkNote') }}</span>
      </template>
    </RegistrationForm>
  </div>
</template>

<script setup>
import RegistrationForm from '@/components/RegistrationForm/index.vue'
import { useAuthStore } from '@/stores/auth'
import OnboardingForm from '@/views/individuals/onboarding/index.vue'
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const hasToken = computed(() => Object.keys(route.query).includes('token'))

const isSubmitted = ref(false)
const authStore = useAuthStore()

const onSubmit = async (formValues) => {
  isSubmitted.value = true
  await authStore.registerUser(1, formValues)
}
</script>

<style lang="scss" scoped></style>
